import { render, staticRenderFns } from "./signingRoomApp.vue?vue&type=template&id=68695916&scoped=true"
import script from "./signingRoomApp.vue?vue&type=script&lang=js"
export * from "./signingRoomApp.vue?vue&type=script&lang=js"
import style0 from "./signingRoomApp.vue?vue&type=style&index=0&id=68695916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68695916",
  null
  
)

export default component.exports